var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      staticStyle: {
        "flex-grow": "0",
        "flex-shrink": "0",
        "padding-left": "4px",
      },
    },
    [
      _c("w-select", {
        attrs: { items: _vm.limitItems, value: _vm.limit, up: "" },
        on: {
          input: function ($event) {
            return _vm.onLimitChange($event)
          },
        },
      }),
      _c(
        "span",
        { staticClass: "amountShown" },
        [
          _c("span", { style: { marginRight: "10px", marginLeft: "10px" } }, [
            _vm._v(_vm._s(_vm.showTotalRecordsText)),
          ]),
          _vm.showTicketFilters
            ? [
                _vm._v(" | "),
                _c(
                  "w-link",
                  {
                    style: { margin: "5px 10px" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleUnread()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.showToggleUnread) + " ")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("w-spacer"),
      _c("w-pagination", {
        attrs: {
          "max-shown-pages": 5,
          "total-pages": _vm.pages,
          value: _vm.page,
        },
        on: {
          input: function ($event) {
            return _vm.onPageChange($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }